import React, { useState } from 'react';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const EMPTY_OVERVIEW_RETRY_LIMIT = 3;
const EMPTY_OVERVIEW_RETRY_DELAY_MS = 2500;

function convert_to_local_time(timestamp) {
    const date = new Date(timestamp)
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDate
}

/* 
receive sensor name, temperature and time from backend
and return result in table format
*/
function Overview(props) {
    const [temperatures, setTemperatures] = useState({})
    const [status, setStatus] = useState('Loading latest temperatures...')

    // return the lastest temperatures for each sensor
    React.useEffect(() => {
        let isCancelled = false;

        function wait(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        async function fetchLatestTemperatures() {
            setStatus('Loading latest temperatures...')

            for (let attempt = 1; attempt <= EMPTY_OVERVIEW_RETRY_LIMIT; attempt++) {
                try {
                    const res = await fetch(`${props.config.backend_url}/get-latest-temperatures/`, {
                        headers: {
                            'Authorization': cookies.get('idToken')
                        }
                    })

                    if (!res.ok) {
                        window.location.href = props.config.login_url;
                        return;
                    }

                    const data = await res.json()
                    const latestTemperatures = data.body || {}

                    if (isCancelled) {
                        return;
                    }

                    if (Object.keys(latestTemperatures).length) {
                        setTemperatures(latestTemperatures)
                        setStatus('')
                        return;
                    }

                    if (attempt < EMPTY_OVERVIEW_RETRY_LIMIT) {
                        setStatus('No latest temperatures found. Retrying...')
                        await wait(EMPTY_OVERVIEW_RETRY_DELAY_MS)
                    } else {
                        setTemperatures({})
                        setStatus('No latest temperatures found.')
                    }
                } catch (error) {
                    if (isCancelled) {
                        return;
                    }

                    console.log('error getting latest temperatures', error)
                    setTemperatures({})
                    setStatus('Unable to load latest temperatures. Please try again.')
                    return;
                }
            }
        }

        fetchLatestTemperatures();

        return () => {
            isCancelled = true;
        }
    }, [props.config.backend_url, props.config.login_url]);

    const temperatureEntries = Object.entries(temperatures || {})


    return (
        <div className="overview-table-wrap">
        <table>
            <thead>
                <tr>
                    <th>Sensor name</th>
                    <th>Last recorded temperature (°C)</th>
                    <th>Time</th>
                </tr>
            </thead>
            <tbody>
                {status ? (
                    <tr>
                        <td colSpan="3">{status}</td>
                    </tr>
                ) : temperatureEntries
                    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
                    .map(([key, [timestamp, temperature]]) => (
                        <tr key={key}>
                            <td>{key}</td>
                            <td>{temperature}</td>
                            <td>{convert_to_local_time(timestamp)}</td>
                        </tr>
                    ))}
            </tbody>
        </table>
        </div>
    );
}

export default Overview
